"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isOnboardingPage = isOnboardingPage;
exports.isCompanyOnboardingPage = isCompanyOnboardingPage;
exports.isEmployeeOnboardingPage = isEmployeeOnboardingPage;
exports.isOnboardingTasksListPage = isOnboardingTasksListPage;
exports.isSuccessPage = isSuccessPage;
exports.getDashboardRedirect = getDashboardRedirect;
exports.getUserDestination = getUserDestination;
exports.redirectUser = redirectUser;
exports.getRedirectPathFromUrl = getRedirectPathFromUrl;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _router = _interopRequireDefault(require("next/router"));

var _routes = require("../../../../constants/routes");

var _constants = require("../constants");

var _ = require("./");

var _constants2 = require("../../../tasks/constants");

var _helpers = require("../../../tasks/helpers");

var _general = require("../../../../helpers/general");

/**
 * Helper function to verify if the current page the user is trying to access is part of the
 * onboarding flow.
 * @param {Object} context
 */
function isOnboardingPage(context) {
  return /^\/onboarding/.test(context.pathname);
}

function isCompanyOnboardingPage(context) {
  return /^\/onboarding\/company/.test(context.pathname);
}

function isEmployeeOnboardingPage(context) {
  return /^\/onboarding\/employee/.test(context.pathname);
}
/**
 * Returns true if it is the onboarding tasks list page
 * @param {Object} context
 */


function isOnboardingTasksListPage(context) {
  return isOnboardingPage(context) && context.pathname.includes('/tasks');
}

function isPendingTasksPage(context) {
  return context.pathname.includes('/pending-tasks');
}
/**
 * Helper function to verify if the current page the user is trying to access is a success page
 * @param {Object} context
 */


function isSuccessPage(context) {
  return context.pathname.includes('/success');
}

function isAuthenticationPage(context) {
  return [_routes.SIGN_IN_ROUTE, _routes.SIGN_UP_ROUTE].includes(context.pathname);
}

function getUserOnboardingPage(user) {
  var role = user.role,
      activeEmployment = user.activeEmployment;

  switch (role) {
    case _constants.userRole.EMPLOYER:
      return _routes.ONBOARDING_COMPANY_ROUTE;

    case _constants.userRole.EMPLOYEE:
      return _routes.ONBOARDING_EMPLOYEE_TASKS_ROUTE.replace('[employmentSlug]', activeEmployment.slug);

    default:
      return null;
  }
}

function getDashboardRedirect() {
  var user = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  switch (user.role) {
    case _constants.userRole.EMPLOYEE:
      return _routes.DASHBOARD_ROUTE;

    case _constants.userRole.SERVICE_PROVIDER:
      return _routes.PEOPLE_ROUTE;

    case _constants.userRole.ADMIN:
      return _routes.ADMIN_DASHBOARD_ROUTE;

    case _constants.userRole.EMPLOYER:
      return _routes.DASHBOARD_ROUTE;
  }

  return null;
}

function getUserPendindTasksPage(_ref) {
  var user = _ref.user,
      tasks = _ref.tasks;
  var role = user.role,
      activeEmployment = user.activeEmployment;
  var isSingleTask = tasks.length === 1;

  switch (role) {
    case _constants.userRole.EMPLOYEE:
      return isSingleTask ? (0, _helpers.getTaskRoute)(tasks[0], _constants2.taskTypes.PENDING_TASK).replace('[employmentSlug]', activeEmployment.slug) : _routes.PENDING_TASKS_EMPLOYEE_TASKS_ROUTE.replace('[employmentSlug]', activeEmployment.slug);

    default:
      return null;
  }
}
/**
 * This function relies on a set of conditions to return the correct URL.
 * @param {Object} user
 * @param {Object} context
 */


function getUserDestination(_ref2) {
  var user = _ref2.user,
      _ref2$context = _ref2.context,
      context = _ref2$context === void 0 ? {
    pathname: _router["default"].pathname
  } : _ref2$context,
      tasks = _ref2.tasks;

  // onboarded user
  if ((0, _.isUserOnboarded)(user)) {
    // user has incomplete tasks
    var hasIncompleteTasks = tasks && tasks.length > 0;

    if (hasIncompleteTasks) {
      if (isPendingTasksPage(context)) return null; // don't redirect, the user is there

      return getUserPendindTasksPage({
        user: user,
        tasks: tasks
      });
    } // user is on /sign-in, /sign-up or onboarding page


    var shouldRedirect = (isAuthenticationPage(context) || isCompanyOnboardingPage(context) || isEmployeeOnboardingPage(context)) && !isOnboardingTasksListPage(context) && !isSuccessPage(context);

    if (shouldRedirect) {
      return getDashboardRedirect(user);
    } // not onboarded, and not on the onboarding pages

  } else if (!isOnboardingPage(context)) {
    return getUserOnboardingPage(user);
  }

  return null;
}
/**
 * Verify if the user should be redirected, composed by specific helpers to get the correct
 * next URL. If no URL is returned, the user is not redirected.
 * @param {Object} user
 * @param {Object} context
 */


function redirectUser(_ref3) {
  var user = _ref3.user,
      context = _ref3.context,
      tasks = _ref3.tasks;
  var redirectDestination = getUserDestination({
    user: user,
    context: context,
    tasks: tasks
  });

  if (redirectDestination) {
    (0, _general.redirectWithContext)(context, redirectDestination);
  }
}
/**
 * If the redirect query param is set, this function gets the url.
 * @param {Object} params
 * @param {Object} params.url
 * @param {Object} params.context
 */


function getRedirectPathFromUrl(_ref4) {
  var url = _ref4.url,
      context = _ref4.context;

  var _url$split = url.split('?'),
      _url$split2 = (0, _slicedToArray2["default"])(_url$split, 2),
      redirectPathname = _url$split2[0],
      _url$split2$ = _url$split2[1],
      redirectQuery = _url$split2$ === void 0 ? '' : _url$split2$;

  var redirectQueryParams = new URLSearchParams(redirectQuery);
  redirectQueryParams.set('redirect', context.asPath);
  return "".concat(redirectPathname, "?").concat(redirectQueryParams.toString());
}